// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c9d85442","455":"a0d4c4d5","700":"c8a4710e","709":"83f101c8","946":"981f4fe8","977":"97d8be56"}[chunkId] + ".chunk.js";
};